import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import type { DropupContent } from '#src/components/Dropup.js'
import { Dropup } from '#src/components/Dropup.js'
import { Cases } from '#src/pages/portfolio/Cases.js'
import { getPortfolioPages } from '#src/pages/portfolio/portfolioData.js'
import type { Route } from './+types/portfolio.route.js'

export async function loader(_args: Route.LoaderArgs) {
  const pages = await getPortfolioPages()
  return { pages }
}

export default function PortfolioLayout({ loaderData }: Route.ComponentProps): ReactNode {
  const dropupContent: DropupContent = {
    title: 'portfolio',
    links: loaderData.pages.map(p => ({
      url: `/portfolio/${p.slug}`,
      text: p.name,
    })),
  }

  return (
    <>
      <Cases links={dropupContent.links} />
      <Outlet />
      <Dropup content={dropupContent} showDropUpAbove={200} />
    </>
  )
}
